<template>
  <div>
    <b-progress :value="progress" max="100" animated striped variant="primary" class="mt-3" />

    <form-wizard color="#7367F0" :title="null" :subtitle="null" shape="square" next-button-text="Suivant"
      finish-button-text="Enregistrer" back-button-text="Précédent" class="steps-transparent mb-3"
      @on-complete="formSubmitted">
      <!-- Personne Evaluée tab -->



      <tab-content title="Informations" icon="feather icon-user">
        <user-objective-view :user-data="userData" />
      </tab-content>

      <!-- Objective tab -->
      <tab-content title="Objectif (Le total des notes doit être égal à 100.)" :before-change="validationForm"
        icon="feather icon-file-text">
        <b-col xl="12" cols="12" class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end">
          <b-button v-b-popover.hover.left.html="popoverHtml" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            title='À propos de la "Note en %" des objectifs' variant="flat-primary" class="d-flex align-items-center">
            <feather-icon icon="InfoIcon" size="25" class="mr-50" />
            Informations

          </b-button>

        </b-col>

        <validation-observer ref="objectiveRules" tag="form">

          <b-card-body class="invoice-padding form-item-section">
            <div ref="form" class="repeater-form">
              <b-row v-for="(objectif, index) in objectiveData" :key="index" ref="row" class="pb-2">
                <b-col cols="12">
                  <div class="d-none d-lg-flex">
                    <b-row class="flex-grow-1 px-1">
                      <b-col cols="12" lg="5">Objectif <span class="text-danger">*</span></b-col>
                      <b-col cols="12" lg="5">Indicateur <span class="text-danger">*</span></b-col>
                      <b-col cols="12" lg="2">Note en %<span class="text-danger">*</span></b-col>

                    </b-row>
                  </div>
                  <div class="d-flex border rounded">
                    <b-row class="flex-grow-1 p-2">
                      <b-col cols="12" lg="5">
                        <label class="d-inline d-lg-none">Objectif <span class="text-danger">*</span></label>
                        <validation-provider
                            :key="'objective-' + objectif.idObjective"
                            :name="'objectif ' + objectif.idObjective"
                            rules="required|noHtmlCode"
                            v-slot="{ errors, failedRules }"
                        >

                        <b-form-textarea
                              v-model="objectif.objectif"
                              :ref="'objective-' + objectif.idObjective"
                              class="mb-2 mb-lg-0"
                              placeholder="Objectif"
                              @blur="saveToLocalStorage"
                              @input="validateInput(index, 'objectif')"
                              rows="1"
                              max-rows="8"
                              style="overflow:hidden; resize:none;"
                              :disabled="isFieldDisabled(objectif)"
                              :state="errors.length > 0 ? false : null"
                              :class="{ 'is-invalid': fieldErrors[`objective_${objectif.idObjective}`] }"

                        />
                          <small class="text-danger" v-if="failedRules.required">
                            Le champ "Objectif" est requis.
                          </small>

                          <small class="text-danger" v-else-if="failedRules.noHtmlCode">
                            Le commentaire ne doit pas contenir de code HTML ou JavaScript.
                          </small>


                          <small v-if="fieldErrors[`objective_${objectif.idObjective}`]" class="text-danger">
                            {{ fieldErrors[`objective_${objectif.idObjective}`] }}
                          </small>



                          <!--                          <small class="text-danger">{{ errors[0] ? `Le champ "Objectif" est requis.` : "" }}</small>-->
<!--                          <small class="text-danger">{{ errors[0] || '' }}</small>-->

                        </validation-provider>
                      </b-col>

                      <b-col cols="12" lg="5">
                        <label class="d-inline d-lg-none">Indicateur<span class="text-danger">*</span></label>
                        <validation-provider
                            :key="'description-' + objectif.idObjective"
                            :name="'description ' + objectif.idObjective"
                            rules="required|noHtmlCode"
                            v-slot="{ errors, failedRules }">

                          <b-form-textarea
                              v-model="objectif.description"
                              class="mb-2 mb-lg-0"
                              placeholder="Indicateur"
                              @blur="saveToLocalStorage"
                              @input="validateInput(index, 'description')"
                              rows="1"
                              max-rows="8"
                              style="overflow:hidden; resize:none;"
                              :state="errors.length > 0 ? false : null"
                              :class="{ 'is-invalid': fieldErrors[`description_${objectif.idObjective}`] }"

                          />
                          <small class="text-danger" v-if="failedRules.required">
                            Le champ "Indicateur" est requis.
                          </small>

                          <small class="text-danger" v-else-if="failedRules.noHtmlCode">
                            Le commentaire ne doit pas contenir de code HTML ou JavaScript.
                          </small>

                          <small v-if="fieldErrors[`description_${objectif.idObjective}`]" class="text-danger">
                            {{ fieldErrors[`description_${objectif.idObjective}`] }}
                          </small>
                        </validation-provider>
                      </b-col>


                      <b-col cols="12" lg="2">
                        <label class="d-inline d-lg-none">Note en % <span class="text-danger">*</span></label>
                        <validation-provider :key="'note-' + objectif.idObjective" #default="{ errors }" :name="'note ' + objectif.idObjective"
                          rules="required|excluded:0">


                          <numeric-input :key="objectiveData[index].note + '-' + maxAllowedPonderation(index)"
                                         @blur="saveToLocalStorage"
                                         :value="objectif.note" :min="0"
                                         :max="maxAllowedPonderation(index)" :step="1" size="lg"
                                         :disabled="isNoteDisabled(index)"
                                         @input="onNoteInput($event, index)"/>

                          <p v-if="totalPonderation === 100" class="text-warning">
                            Le total des notes est de 100 %.
                          </p>
                          <small class="text-danger">{{ errors[0] ? `Le champ "Note" est requis.` : "" }}</small>
                        </validation-provider>
                      </b-col>


                    </b-row>
                    <div class="d-flex flex-column justify-content-between border-left py-50 px-25">
                      <feather-icon size="16" icon="XIcon" class="cursor-pointer"
                        @click="removeItem(index, objectif)" />
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="addNewItemInItemForm">
              Ajouter un objectif
            </b-button>
          </b-card-body>

        </validation-observer>

      </tab-content>




    </form-wizard>
    <div>
      <b-modal id="modal-sm" v-model="isModalActive" modal-class="modal-primary" ok-only ok-title="OK" centered
        size="sm" :title="modalTitle" @hide="onModalClosed" @ok="confirmUpdateObjective">
        <b-form-group>
          <b-form-radio-group v-model="isValid" :options="options" class="demo-inline-spacing" name="radio-inline" />
        </b-form-group>
      </b-modal>

      <validation-observer ref="validationN2" tag="form">
        <b-modal id="modal-sm" v-model="isModalActiveN2" modal-class="modal-primary" ok-only ok-title="OK" centered
          size="sm" :title="modalTitleN2" @hide="onModalClosed" @ok.prevent="validN2UpdateObjective">

          <b-form-group>
            <b-form-radio-group v-model="isValidN2" :options="optionsN2" class="demo-inline-spacing"
              name="radio-inline" />
          </b-form-group>

          <div v-if="isValidN2 === false" class="mb-2">
            <validation-provider
                name="Commentaire de rejet"
                rules="required|noHtmlCode"
                v-slot="{ errors, failedRules }"
            >


              <label for="textarea-default" class="mt-2 font-weight-bold">Commentaire de rejet</label>
              <b-form-textarea id="textarea-default" v-model="userObjective.descriptionRejet"
                               placeholder="..." rows="3"
                               @input="validateRejectionComment"
                               :state="errors.length === 0 ? null : false" />
              <small class="text-danger" v-if="failedRules.required">
                Un commentaire est requis.
              </small>

              <small class="text-danger" v-else-if="failedRules.noHtmlCode">
                Le commentaire ne doit pas contenir de code HTML ou JavaScript.
              </small>


            </validation-provider>
          </div>

        </b-modal>
      </validation-observer>



      <b-modal id="modal-sm" v-model="isModalActiveNote" modal-class="modal-primary" ok-only ok-title="OK" centered
        size="sm" title="La Note des objectifs en % " @hide="onModalClosed" @ok="confirmNote">

        <b-form-group>
          <b-col xl="12" cols="12" class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end">
            <b-button v-b-popover.hover.left.html="popoverText" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              title='À propos de la "Note en %" des objectifs' variant="flat-primary" class="d-flex align-items-center">
              <feather-icon icon="InfoIcon" size="25" class="mr-50" />
              Informations

            </b-button>

          </b-col>
          <p>Le pourcentage indique le poids attribué à la partie « Objectifs » dans l’évaluation. </p>

          <numeric-input id="demo-sb" v-model="userObjective.note" :min="50" :max="80" :step="1" />

          <p class="text-warning mt-1">
            La note doit être comprise entre 50 et 80 %.
          </p>

          <h5>
            Valeur : {{ userObjective.note }} %
          </h5>

        </b-form-group>
      </b-modal>
      <validation-observer ref="validation" tag="form">

      <b-modal v-if="!userObjective.valid" id="modal-sm" v-model="isModalActivesEvalue" modal-class="modal-primary"
        ok-only ok-title="Confirmer" centered size="sm" title="Validation de l'évaluation finale" @hide="onModalClosed"
        @ok="confirmEvalueObjective">

        <div>

          <b-form-group>

            <label class="font-weight-bold">
              Veuillez noter que vous avez 5 jours calendaires pour effectuer cette validation. Passé ce délai, la
              validation sera automatique.
            </label>
          </b-form-group>

          <b-form-group>

            <b-form-checkbox id="confirm-validation" v-model="isObjectiveValidated" name="check-button" switch inline>
              Objectif Accepté
            </b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <label for="textarea-default" class="mt-2 font-weight-bold">Commentaire</label>
            <validation-provider :key="'textarea-comment' " #default="{ errors }"
                                 :name="'commentaire' " :rules="{ noHtmlCode: true }">

            <b-form-textarea id="textarea-default" v-model="comment"  @input="validateComment"
                             placeholder="Ajoutez un commentaire..." rows="1"
                             max-rows="8"
            />
              <small class="text-danger">{{ errors[0] || '' }}</small>

            </validation-provider>

          </b-form-group>
        </div>
      </b-modal>
      </validation-observer>

    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import UserObjectiveView from './UserObjectiveView.vue'
import {
  saveUserObjective,
  updateUserObjective,
  getUserObjectivesByYears,
  getIdUserObjective,
  updateValidObjectif,
} from '@/services/UserObjectiveService'
import { required } from '@validations'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import NumericInput from '@/util/NumericInput.vue'
import {

  BRow,
  BCol,
  BCardBody,
  BButton,
  BFormTextarea,
  BModal,
  BFormRadioGroup, BProgress, BFormSpinbutton, BFormCheckbox, VBPopover,BFormGroup
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import 'animate.css'
import { getJsonFromStorage } from "@/util/storageUtils";
import {getSetting} from "@/services/SettingService";
import { extend } from 'vee-validate'
const forbiddenPatterns = [
  /<\s*\/?\s*[a-zA-Z][a-zA-Z0-9_-]*\s*.*?>/i,
  /<\s*script/i,
  /<\s*style/i,
  /on\w+\s*=/i,
  /(javascript|data|vbscript):/i,
  /(\$\{[^}]*\}|\{\{[^}]*\}\}|#\{[^}]*\})/,
  /(%3C|%3E|&#\d+;|&#x[0-9a-fA-F]+;|\\u[0-9a-fA-F]{4}|\\x[0-9a-fA-F]{2})/i,
  /<!--|--\>/i
];
extend('noHtmlCode', {
  validate: (value) => {
    if (!value) return true; // vide ok
    // Vérifie chaque pattern du tableau
    for (const pattern of forbiddenPatterns) {
      if (pattern.test(value)) {
        return false; // interdit si un pattern match
      }
    }
    return true; // tout est ok
  },
  message: 'Le texte ne doit pas contenir de code HTML ou JavaScript.',
});



export default {
  components: {
    NumericInput,
    FormWizard,
    TabContent,
    UserObjectiveView,
    // SignatureUploadView,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCardBody,
    BButton,
    BModal,
    BFormRadioGroup,
    BFormTextarea,
    BProgress,
    BFormCheckbox,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  BFormGroup
  },
  props: {
    index: Number
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  mixins: [heightTransition],
  mounted() {
    this.initTrHeight()

  },
  async created() {



    window.addEventListener('resize', this.initTrHeight)
    try {
      const response = await getSetting();
      if (response && response.yearObjective) {
        this.currentYear = response?.yearObjective?.year;
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      this.currentYear = new Date().getFullYear();
    }
    this.objectiveData = Array.from({ length: 5 }, () => ({
      objectif: '',
      description: '',
      note: null,
      createdBy: null,
      idObjective: this.nextObjectiveId++,
    }));
    await this.fetchUserObjectiveData()


  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  data() {
    return {
      currentYear: null,
      objectiveRefs: [],
      selectedImage: ref(null),
      objectives: [{ objectif: '', description: '' }],
      nextObjectiveId: 1,
      fieldErrors: {},
      objectiveData: [],
      // signatureSend: null,
      userObjective: {
        id: null,
        users: { id: null },
        objectifs: [],
        signature: null,
        signatureObjective: [{ signature: null, users: { id: null } }],
        valid: false,
        years: null,
      },
      userData: ref(null),
      isModalActive: false,
      isModalActivesEvalue: false,
      isModalActiveN2: false,
      modalTitleN2: 'Validation par N+2',
      modalTitle: 'Confirmation',
      isRejectedByN2: false,
      optionsN2: [
        { text: 'Valider les Objectifs', value: true },
        { text: 'Rejeter les Objectifs', value: false },
      ],
      required,
      progress: null,
      loading: false,
      value: 50,
      isValid: false,
      isValidN2: true,
      isObjectiveValidated: false,
      comment: null,
      isModalActiveNote: false,
      popoverHtml: `
        <ul style="padding-left: 1.2em; line-height: 1.8; margin: 0;">
          <li>Quand vous remplissez vos objectifs de l’année, pensez à donner un pourcentage à chaque objectif. Cela montre à quel point il est important.</li>
          <li>Le total des notes doit être égal à <strong>100 %</strong>.</li>
          <li>Ces pourcentages comptent dans l’évaluation de votre travail en fin d’année.</li>
          <li>D’autres choses sont aussi prises en compte pour votre évaluation globale, comme :
            <ul style="margin-top: 0.25em;">
              <li>Savoir-faire</li>
              <li>Savoir-être</li>
            </ul>
          </li>
        </ul>
      `,
      popoverText: `
        <p>
          Le pourcentage que vous indiquez ici sert à dire <strong>quelle place prennent les objectifs</strong> dans l’évaluation de fin d’année du collaborateur.
        </p>
        <p>
          Ce pourcentage doit être entre <strong>50&nbsp;% et 80&nbsp;%</strong>.
        </p>
        <p>
          Le reste du pourcentage servira à évaluer d'autres aspects du travail :
        </p>
        <ul style="padding-left: 1.2em; margin: 0;">
          <li><strong>Savoir-faire</strong></li>
          <li><strong>Savoir-être</strong></li>
        </ul>
        <p class="mt-50">
          Choisissez un pourcentage qui montre bien l’importance des objectifs dans le travail du collaborateur.
        </p>
      `

    }
  },


  computed: {
    canAccessObjectivePage() {

      if (!this.userObjective) return false;
      const userData = this.getStoredUserData();

      if (!userData) return false;

      // if (this.isRapport) return false;

      const isOwner = userData.id === this.userObjective.users.id;
      const isManager = this.isHierarchyModifying();
      const isN2 = this.isHierarchyN2();

      return isOwner || isManager || isN2;
    },
    totalPonderation() {
      return this.objectiveData.reduce((sum, obj) => sum + (obj.note || 0), 0);
    },
    maxAllowedPonderation() {
      return (index) => {
        const remaining = 100 - (this.totalPonderation - (this.objectiveData[index].note || 0));
        return remaining > 0 ? remaining : 0;
      };
    },
    options() {
      return [
        { text: 'Envoyer au Manager N+2', value: false, disabled: false },
        { text: 'Valider les Objectifs', value: true, disabled: this.isRejectedByN2 },
      ];
    }
  },

  methods: {
    buildErrorMessage(error) {
      return `${error.message} "${error.invalidChar}" à la position ${error.position}`;
    },
    validateInput(index, field) {
      const originalValue = this.objectiveData[index][field]
      if (!originalValue) return
      return !forbiddenPatterns.some(pattern => pattern.test(originalValue));
    },

    // Méthode pour sanitiser les commentaires
    validateComment() {
      if (!this.comment) return



      return !forbiddenPatterns.some(pattern => pattern.test(this.comment));

    },

    // Méthode pour sanitiser la description de rejet
    validateRejectionComment() {
      if (!this.userObjective.descriptionRejet) return





      return !forbiddenPatterns.some(pattern => pattern.test(this.userObjective.descriptionRejet));
    },
    replaceString() {
      return this.userObjective.descriptionRejet.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    },
    saveToLocalStorage() {
      localStorage.setItem('tempObjectives', JSON.stringify(this.objectiveData));
    },
    onModalClosed(event) {
      if (event.trigger === 'headerclose') {

        this.loading = false; // Désactive l'état de chargement
        this.progress = 0;
      }
    },

    isFieldDisabled(objectif) {
      const currentUserId = this.getStoredUserData()?.id

      return objectif.createdBy && objectif.createdBy !== currentUserId
    },

    onNoteInput(value, index) {
      const newValue = Number(value);
      if (isNaN(newValue) || newValue < 0) {
        return; // Ignore les valeurs invalides
      }

      let totalWithoutCurrent = 0;
      this.objectiveData.forEach((item, i) => {
        if (i!== index) {
          totalWithoutCurrent += Number(item.note) || 0;
        }
      });

      const maxAllowed = 100 - totalWithoutCurrent;

      if (newValue <= maxAllowed) {
        this.objectiveData[index].note = newValue;
      } else {
        this.objectiveData[index].note = parseFloat(maxAllowed.toFixed(1));


        this.$set(this.objectiveData, index, {
          ...this.objectiveData[index],
          note: parseFloat(maxAllowed.toFixed(1))
        });

      }


    },

    isNoteDisabled(index) {
      const note = Number(this.objectiveData[index].note);

      // Si total = 100, désactive ce champ s’il est vide, null ou 0
      return this.totalPonderation >= 100 && (isNaN(note) || note === 0);
    },

    isOnlyOneNoteFull(index) {
      return (
        this.objectiveData.filter((o) => Number(o.note) === 100).length === 1 &&
        this.objectiveData.every((o, i) => {
          if (i === index) return true;
          const note = Number(o.note);
          return note === 0 || isNaN(note);
        })
      );
    },
    isLastHierarchy() {
      const userData = this.getStoredUserData();

      return (
          userData &&
          userData.id !== this.userObjective.users.id &&
          (!userData.usersHierarchique || userData.usersHierarchique.length === 0)
      );
    },

    confirmNote() {
      if (this.isHierarchyN2()) {
      
        this.isModalActiveN2 = true

      } else if (this.isLastHierarchy()) {

        this.modalTitleN2 = "Validation"
        this.isModalActiveN2 = true

      } else if (this.isHierarchyModifying()) {
        this.isModalActive = true
        this.isRejectedByN2 = this.userObjective.rejetHierachyn === 2;

      }
    },

    updateValidationN2Options() {
      if (this.userObjective &&( this.userObjective.rejetHierachyn === 2 || this.userObjective.status === 'TRANSMIT_HIERARCHY_2')) {
        this.isRejectedByN2 = true;
      } else {
        this.isRejectedByN2 = false;
      }
    },
    updateValidationOptions() {
      if (this.userObjective &&( this.userObjective.rejetHierachyn === 1 || this.userObjective.status === 'PROPOSE')) {
        this.isRejectedByN2 = true;
      } else {
        this.isRejectedByN2 = false;
      }
    },
    async confirmEvalueObjective() {
      this.userObjective.valid = this.isObjectiveValidated;
      this.userObjective.description = this.comment;
      await updateValidObjectif(this.userObjective.id, this.getStoredUserData().id, this.userObjective)
      this.showToast("Objectif validé avec succès.", "success", 'EditIcon');
    },
    getStoredUserData() {
      const storedUserData = getJsonFromStorage('userData')
      return storedUserData ? storedUserData : null
    },
    async fetchUserObjectiveData() {


      const userObjectiveId = this.$route.query.id
      let year = this.$route.query.year
      if (userObjectiveId) {
        try {
          const userData = this.getStoredUserData();

          const response = await getIdUserObjective(userObjectiveId,userData.id)


          if (response) {
            this.userObjective = response
            if (!this.canAccessObjectivePage) {
              if (this.$route.name !== 'profile') {
                await this.$router.replace({ name: 'profile' });
              }
              return;
            }


            this.objectiveData = response.objectifs || [{ objectif: '', description: '' }]
            if (this.objectiveData.length > 0) {
              const maxId = Math.max(...this.objectiveData.map(o => o.idObjective || 0));
              this.nextObjectiveId = maxId + 1;
            } else {
              this.nextObjectiveId = 1;
            }

            this.userData = this.userObjective.users

            this.updateValidationOptions()

            if (!this.userObjective.note) {
              this.userObjective.note = 50

            }
            // this.userData = response.data.users

          }
        } catch (error) {
          console.error('Error fetching userObjective data:', error)
        }
      } else {
        const userData = this.getStoredUserData()
        if (!year) {
          year = this.currentYear !== null ? this.currentYear : new Date().getFullYear();
        }

        if (userData) {
          try {

            const response = await getUserObjectivesByYears(userData.id,year)
            if (response) {
              this.userObjective = response
              this.objectiveData = response.objectifs || [{ objectif: '', description: '' }]

              this.userData = userData
              // this.signatureSend = response.data.signature
            } else {
            

              this.userData = userData
              const saved = localStorage.getItem('tempObjectives');
                if (saved) {
                  this.objectiveData = JSON.parse(saved);
                }
            }
          } catch (error) {
            console.error('Error fetching user objectives by year:', error)
          }
        }
      }

      if (this.userObjective.valid) {
        this.progress = 50;
        this.$swal({
          title: 'Alerte!',
          text: "L'objectif est déjà validé et ne peut pas être modifié.",
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        this.progress = 100;

        await this.$router.push({name: 'objectif_print', params: {id: this.userObjective.id, isRapport: 0}})

      } else if (this.isAnySignatureConfirmed()) {
        this.progress = 50;

        this.$swal({
          title: 'Alerte!',
          text: "L'objectif a déjà été confirmé par votre manager. Toute modification doit être validée par lui.",
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        await this.$router.push({name: 'objectif_print', params: {id: this.userObjective.id, isRapport: 0}})
        this.progress = 100;

      }


      this.objectiveData = this.objectiveData.sort((a, b) => a.idObjective - b.idObjective);


    },

    addNewItemInItemForm() {
      this.$refs.form.style.overflow = 'hidden'
      this.objectiveData.push({ objectif: '', description: '' ,  note: null, createdBy: null, idObjective: this.nextObjectiveId++})
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
        setTimeout(() => {
          this.$refs.form.style.overflow = null
        }, 350)
      })
    },

    removeItem(index, objectif) {
      if (!this.isFieldDisabled(objectif)) {
        this.objectiveData.splice(index, 1)
        this.objectiveData.forEach((obj, i) => {
          obj.idObjective = i + 1;
        });
        this.nextObjectiveId = this.objectiveData.length + 1;

        this.trTrimHeight(this.$refs.row[0].offsetHeight)
      }
    },

    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },

    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.objectiveRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },

    async updateObjective(newUserObjective) {


      try {
        const userData = this.getStoredUserData()


        newUserObjective = await updateUserObjective(this.userObjective.id, userData.id, this.userObjective)


        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Objectif mis à jour avec succès',
            icon: 'EditIcon',
            variant: 'success',
          },
        })
        localStorage.removeItem('tempObjectives');
        await this.$router.push({name: 'objectif_print', params: {id: newUserObjective.id, isRapport: 0}})

      }catch (error) {
        this.progress = 0

        if (error.response?.data) {
          const data = error.response.data;

          if (Array.isArray(data.errors) && data.errors.length > 0 &&
              !error.response.data?.errors[0]?.fieldId) {
            this.fieldErrors = {};
            error.response.data.errors.forEach(err => {
              const message = err.message + " " + err.invalidChar + " à la position " + err.position + ".";
              this.$set(this.fieldErrors, err.fieldId, message);
            });
          }
        }
        this.loading = false;

      }

    },

    async formSubmitted() {
      if (!this.loading) {
        this.progress = 0; // Initialise la progression à 0
        this.loading = true; // Active l'état de chargement

        try {
          this.progress = 10; // Mise à jour initiale

          let total = 0;
          this.objectiveData.forEach((item, i) => {
            total += Number(item.note) || 0;
          });

          if (total !== 100) {

            this.$swal({
              title: 'Alerte!',
              text: "Le total des Notes en % doit être égal à 100 !",
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })

            this.progress = 0;
            this.loading = false;

            return

          }


          if (this.userObjective.valid) {
            this.progress = 50;
            this.$swal({
              title: 'Alerte!',
              text: "L'objectif est déjà validé et ne peut pas être modifié.",
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
            this.progress = 100;

            await this.$router.push({name: 'objectif_print', params: {id: this.userObjective.id, isRapport: 0}})

          } else if (this.isAnySignatureConfirmed()) {
            this.progress = 50;

            this.$swal({
              title: 'Alerte!',
              text: "L'objectif a déjà été confirmé par votre manager. Toute modification doit être validée par lui.",
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
            await this.$router.push({name: 'objectif_print', params: {id: this.userObjective.id, isRapport: 0}})
            this.progress = 100;

          } else {
            this.progress = 10;
            this.objectiveData.forEach((obj, i) => {
              obj.idObjective = i + 1;
            });
            this.userObjective.objectifs = this.objectiveData

            try {
              if (this.userObjective.id) {
                this.progress = 30;

                if (!this.isHierarchyModifying() && !this.isHierarchyN2()) {
                  this.progress = 60;
                  await this.updateObjective()
                  this.progress = 80;

                } else {
                  this.isModalActiveNote = true

                }

              } else {
                this.userObjective.users = this.userData
                this.progress = 30;

                const newUserObjective = await saveUserObjective(this.userObjective)
                this.progress = 60;
                localStorage.removeItem('tempObjectives');
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Objectif enregistré avec succès',
                    icon: 'EditIcon',
                    variant: 'success',
                  },
                })
                this.progress = 90;

                await this.$router.push({name: 'objectif_print', params: {id: newUserObjective.id, isRapport: 0}})
              }
              this.progress = 100;

            } catch (error) {

              this.progress = 0

              if (error.response?.data) {
                const data = error.response.data;

                if (Array.isArray(data.errors) && data.errors.length > 0 &&
                    !error.response.data?.errors[0]?.fieldId) {
                  this.fieldErrors = {};
                  error.response.data.errors.forEach(err => {
                    const message = err.message + " " + err.invalidChar + " à la position " + err.position + ".";
                    this.$set(this.fieldErrors, err.fieldId, message);
                  });
                }
              }
              this.loading = false;
            }
          }
        } catch (error) {

          this.progress = 0

          if (error.response?.data) {
            const data = error.response.data;

            if (Array.isArray(data.errors) && data.errors.length > 0 &&
                !error.response.data?.errors[0]?.fieldId) {
              this.fieldErrors = {};
              error.response.data.errors.forEach(err => {
                const message = err.message + " " + err.invalidChar + " à la position " + err.position + ".";
                this.$set(this.fieldErrors, err.fieldId, message);
              });
            }
          }
          this.loading = false;
        }
      }
    },

    confirmUpdateObjective() {
      this.userObjective.validHierachy = this.isValid
      this.userObjective.descriptionRejet = null
      this.userObjective.rejetHierachyn = null
      this.userObjective.dateRejet = null
      this.updateObjective()
    },

    validN2UpdateObjective() {
      if (this.isValidN2 === false) {
        this.$refs.validationN2.validate().then(valid => {
          if (!valid) return;

          this.userObjective.validHierachy = this.isValidN2;
          this.updateObjective();
        });
      } else {
        // Si ce n'est pas un rejet, pas besoin de valider le commentaire
        this.userObjective.validHierachy = this.isValidN2;
        this.updateObjective();
      }
    },
    isHierarchyModifying() {
      if (this.userObjective && this.userObjective.signatureObjective) {
        const userData = this.getStoredUserData();

        const userSignatureObjective = this.userObjective.signatureObjective.find(sigObj => sigObj.users.id === userData.id);

        return userSignatureObjective && userSignatureObjective.hierarchyN ===1;

      }
    },
    isHierarchyN2() {

      if ( this.userObjective && this.userObjective.signatureObjective) {
        const userData = this.getStoredUserData();

        const userSignatureObjective = this.userObjective.signatureObjective.find(sigObj => sigObj.users.id === userData.id);
        if (userSignatureObjective && userSignatureObjective.hierarchyN === 2) {
          return true;
        }
      }
      return false;
    },

    isAnySignatureConfirmed() {
      // Check if the user is not modifying hierarchy and the userObjective exists
      if (!this.isHierarchyModifying() && !this.isHierarchyN2() && this.userObjective) {
        // Return true if the status of userObjective is "CONFIRME"
        return this.userObjective.status === "VALIDE_HIERARCHY_1" || this.userObjective.status === "VALIDE_HIERARCHY_2" || this.userObjective.status === "TRANSMIT_HIERARCHY_2";
      }
      // Return false if the above conditions are not met
      return false;
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
</style>

<style scoped>
/* Spécificité plus élevée */
button.violet-button {
  display: flex;
  /* Flexbox pour aligner les enfants */
  align-items: center;
  /* Aligner verticalement */
  justify-content: center;
  /* Centrer horizontalement */
  background-color: rgb(115, 103, 240) !important;
  border-color: rgb(115, 103, 240) !important;
  color: #ffffff !important;
  border: 1px solid rgba(114, 103, 240, 0) !important;
  text-align: center;
  transition: background-color 0.3s ease, box-shadow 0.3s ease !important;
  font-weight: bold;
  font-family: "Montserrat", Helvetica, Arial, serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
}

button.violet-button:hover {
  background-color: rgb(115, 103, 240) !important;
}

/* Ajustement de l'espacement entre le texte et l'icône */
button.violet-button .align-middle {
  margin-right: .5rem;
  /* Espacement entre le texte et l'icône */
}



input.note-input {
  appearance: auto;
  -moz-appearance: auto;
  -webkit-appearance: auto;
}
</style>
